export const DEFAULT_COURSE_SORT = "price-asc";

export const COURSE_SORTS = ["date", "alpha", "price-asc", "price-desc"];

export function normalizeCourseSort(value) {
  return COURSE_SORTS.includes(value) ? value : DEFAULT_COURSE_SORT;
}

export function getCourseSortFromUrl(url) {
  const requestedSort =
    url.searchParams.get("sort") || url.searchParams.get("orderby");
  return normalizeCourseSort(requestedSort);
}

export function setCourseSortInUrl(url, sort) {
  const nextUrl = new URL(url.toString());
  nextUrl.searchParams.set("sort", normalizeCourseSort(sort));
  nextUrl.searchParams.delete("orderby");
  return nextUrl;
}

function numericPrice(course) {
  const price = Number.parseFloat(course.price);
  return Number.isFinite(price) ? price : null;
}

export function getSortedCourseIndices(courses, sort) {
  const selectedSort = normalizeCourseSort(sort);
  const indices = courses.map((_, index) => index);

  indices.sort((a, b) => {
    if (selectedSort === "alpha") {
      return courses[a].title.localeCompare(courses[b].title);
    }

    if (selectedSort === "price-asc" || selectedSort === "price-desc") {
      const priceA = numericPrice(courses[a]);
      const priceB = numericPrice(courses[b]);

      // Courses without a displayed numeric price remain at the end in both
      // directions. A real zero-dollar class sorts first when ascending.
      if (priceA === null) return priceB === null ? a - b : 1;
      if (priceB === null) return -1;

      const difference =
        selectedSort === "price-asc" ? priceA - priceB : priceB - priceA;
      return difference || a - b;
    }

    return courses[a].next_date - courses[b].next_date || a - b;
  });

  return indices;
}
